module.exports = __webpack_public_path__ + "img/lg_ring_y_i_0_1.8724f202.png";